import { ASSETS_PATH, CLASS_IS_HIDE } from './../../shared/global/base';
import { reaction } from 'mobx';
import { CLASS_IS_ACTIVE } from '../../shared/global/base';
import { getHighlightValues } from '../../shared/elements/NavHighlight';
import { scrollToTop, subscribeToOverlayClose, closeOverlay, showOverlay } from '../Popup';
import { ChangePopupStore } from './ChangePopupStore';
import { goFish } from '../../shared/global/api';
import cookies from '../../shared/utils/storage/cookies';
import { isMenu, redirectToCart, redirectToMenu } from '../../shared/global/navigation';
import { dominosStore } from '../../main';
import Loader from '../../shared/utils/loader';
import { getAppDefaultMessage } from '../../shared/global/dictionary';
import { dataLayerPush } from '../../shared/global/datalayers/datalayers';
import { showTime } from '../../shared/utils/date';

const CLASS_MAP_ALONE = 'm-MapAllPlaces--on-popup';
const CLASS_2COLS = 'm-PopupChangePlace__container--2cols';
const CLASS_ONLY_HEADING = 'm-Popup__heading--tabbed';
let resizeTimeout: number;

const CONFIG_COOKIE = 'pcpconfig';

export { initAfterDynamicImport, setConfigPCP };

let localSetted = false;
function initAfterDynamicImport(dom: HTMLElement) {
    if (!localSetted) {
        dominosStore.localStore.getCurrentLocal().then(() => init(dom));
        localSetted = true;
    } else {
        init(dom);
    }
}

function init(dom: HTMLElement) {
    // Get config if exists
    const config = JSON.parse(cookies.read(CONFIG_COOKIE) || '{}');
    cookies.erase(CONFIG_COOKIE);

    // Create store
    const store = new ChangePopupStore(dom, config);

    // Setup reactons

    store.disposers.push(
        reaction(
            () => store.deliveryType,
            deliveryType => {
                deliveryTypeChange(deliveryType, store);
            }
        )
    );

    store.disposers.push(
        reaction(
            () => store.step,
            step => {
                stepChange(step, store);
            }
        )
    );

    store.disposers.push(
        reaction(
            () => store.address,
            address => {
                store.form.fillInFields(address);
            }
        )
    );

    store.disposers.push(
        reaction(
            () => store.step2Error,
            msg => {
                manageStep2Error(msg, store);
            }
        )
    );

    // Manage user/document events

    dom.addEventListener('click', e => {
        handleButtonClicks(e, store);
    });

    window.addEventListener('resize', e => {
        handleResize(e, store);
    });

    // Prevent closing popup when mobile map is loaded
    dom.parentNode.parentNode
        .querySelector('[data-jselement-arrowback]')?.addEventListener('click', e => {
            handleBack(e, store);
        });

    // Cleanup on close
    subscribeToOverlayClose(() => {
        const paramForDLayer = store.deliveryType == 1 ? 'delivery' : 'pickup';
        dataLayerPush('orderlayer', { evParam1: 'close', evParam2: paramForDLayer });
        store.fireDisposers();
    });

    // Startup elements for popup

    // Delivery tab
    if (typeof store.config.delivery !== 'undefined') {
        store.chandeDeliveryType(store.config.delivery);
    } else {
        store.chandeDeliveryType(1);
    }

    // Message under the header
    if (store.config.header) {
        store.refs.message.textContent = store.dictionary.message[store.config.header];
    }

    // Fill in address if exists
    try {
        const aid: AddressData = dominosStore.localStore.deliveryAddress;
        if (aid) {
            store.saveAddress(aid);
        }
    } catch (e) { }

    // Normally we start from step 1
    let step: ChangePopupStepsType = 1;
    if (store.config.start === 2) {
        // From some places we can jump into second step with address and local selected
        if (store.address) {
            const savedLocal = dominosStore.localStore.local;
            if (savedLocal) {
                // We have address and local so set local and go to 2
                store.changeLocal(savedLocal, 0);
                step = 2;
            }
        }
    }

    store.changeStep(step);
}

function deliveryTypeChange(deliveryType: DeliveryType, store: ChangePopupStore) {
    // Update tab buttons
    store.refs.btns.map(btn => {
        if (btn.type === deliveryType) {
            btn.ref.classList.add(CLASS_IS_ACTIVE);
            store.refs.line.style.transform = getHighlightValues(btn.ref).transform;
        } else {
            btn.ref.classList.remove(CLASS_IS_ACTIVE);
        }
    });
    // Show/hide delivery type sections
    store.refs.sections.map(sec => {
        if (sec.type === deliveryType) {
            sec.ref.classList.remove(CLASS_IS_HIDE);
        } else {
            sec.ref.classList.add(CLASS_IS_HIDE);
        }
    });

    // First step view
    if (deliveryType === 0) {
        // do dataLayerPush only if onlyMapOnOverlay and isMBreakpoint or no onlyMapOnOverlay 
        if (!store.onlyMapOnOverlay || (store.onlyMapOnOverlay && dominosStore.isMBreakpoint)) {
            dataLayerPush('orderlayer', { evParam1: 'view', evParam2: 'pickup', evParam3: '1' });
        }
        !store.onlyMapOnOverlay && store.refs.steps[0].classList.add(CLASS_2COLS);
        // Map should be inited only on desktop step 1
        if (dominosStore.isMBreakpoint && store.step === 1 && !store.onlyMapOnOverlay) {
            store.initMap(false);
        }
    } else {
        // do dataLayerPush only if onlyMapOnOverlay and isMBreakpoint or no onlyMapOnOverlay
        if (!store.onlyMapOnOverlay || (store.onlyMapOnOverlay && dominosStore.isMBreakpoint)) {
            dataLayerPush('orderlayer', { evParam1: 'view', evParam2: 'delivery', evParam3: '1' });
        }
        
        store.refs.steps[0].classList.remove(CLASS_2COLS);
        // Focus on first form field
        const city = store.refs.form.City;
        if (city && !city.value) {
            city.focus();
        }
    }
    // Message above the form
    const formInfo = store.dictionary.formtext[deliveryType];
    store.refs.formtext.textContent = formInfo;
    store.refs.formtext.classList[formInfo ? 'remove' : 'add'](CLASS_IS_HIDE);
}

async function stepChange(step: number, store: ChangePopupStore) {
    if (step === 3) {
        if (!store.onlyMapOnOverlay) {
            dataLayerPush('orderlayer', { evParam1: 'view', evParam2: 'pickup', evParam3: '3' });
            // Map view with heading only without tabs, icons etc. (mobile only)
            store.refs.title.textContent = store.dictionary.title.mobilemap;
            store.refs.nav.classList.add(CLASS_IS_HIDE);
            store.refs.title.parentElement.classList.remove(CLASS_ONLY_HEADING);
            store.refs.form.classList.add(CLASS_IS_HIDE);
            store.refs.map.classList.add(CLASS_MAP_ALONE);
            // Map
            store.refs.map.parentElement.style.display = 'block';
            // store.initMap(true);
            store.initMap(false);

        } else {
            dataLayerPush('orderlayer', { evParam1: 'view', evParam2: 'pickup', evParam3: '3' });
            openMapPopup(store)
        }
    }
    // Step 1 or 2
    else {
        // on onlyMapOnOverlay variant, header has user name
        if (store.onlyMapOnOverlay) {
            store.refs.title.innerHTML = `<span>${store.dictionary.title.hi}</span> ${store.dictionary.title.default}`
        } else {
            store.refs.title.textContent = store.dictionary.title.default;
        }
        const deliveryType = store.deliveryType;
        const deliveryTypeForAnalytics = store.deliveryType === 1 ? 'delivery' : 'pickup';
        // Form & map (1)
        if (step === 1) {

            store.refs.form.classList.remove(CLASS_IS_HIDE);
            !store.onlyMapOnOverlay && store.refs.map.classList.remove(CLASS_MAP_ALONE);

            // Map should be inited only on desktop step 1
            if (dominosStore.isMBreakpoint && deliveryType === 0 && !store.onlyMapOnOverlay) {
                store.initMap(false);
            }
        }
        // Local info (2)
        else if (step === 2) {
            dataLayerPush('orderlayer', { evParam1: 'view', evParam2: deliveryTypeForAnalytics, evParam3: '2' });
            store.refs.localinfo.address.innerHTML = `${store.address.City}<br>${store.address.Street
                } ${store.address.HouseNr}${store.address.FlatNr ? '/' + store.address.FlatNr : ''}`;

            store.setStep2Error('');

            //
            let header = store.dictionary.localinfo.header[deliveryType];
            let subheader = '';
            let timetitle = store.dictionary.localinfo.time.title[deliveryType];
            let btnaccept = store.dictionary.localinfo.button[deliveryType];
            store.refs.localinfo.btnaccept.setAttribute('data-delivery', deliveryType.toString());
            let errormessage = '';
            let time = '';
            let timeinfo = store.dictionary.localinfo.time.info[deliveryType];

            // Local is closed
            if (!store.local.IsActive) {
                timetitle = store.dictionary.localinfo.time.title.closed;
                btnaccept = store.dictionary.localinfo.button.closed;
                errormessage = store.local.InactiveMessage;
            }
            // Local is open so check other features
            else {
                // Near local (so delivery not possible) is available for pickup
                if (deliveryType === 1 && store.distance) {
                    header = store.dictionary.localinfo.header.deliveryNotPossible;
                    subheader = store.dictionary.localinfo.header.pickupEncourage.replace(
                        '{0}',
                        `<b>${store.distance > 0.99 ? Math.round(store.distance) : store.distance.toFixed(1).replace('.', ',')} ${store.dictionary.localinfo.distance
                        }</b>`
                    );
                    timetitle = store.dictionary.localinfo.time.title[0];
                    timeinfo = store.dictionary.localinfo.time.info[0];
                    btnaccept = store.dictionary.localinfo.button[0];
                    store.refs.localinfo.btnaccept.setAttribute('data-delivery', '0');
                }
                // Check delivery/pickup hour
                try {
                    const deliveryTime: DeliveryTimeResponse = await goFish({
                        api: 'config',
                        data: { LocalId: store.local.Id, DeliveryType: deliveryType }
                    });
                    time = showTime(new Date(deliveryTime.Data.DefaultTime));
                } catch (e) { }
            }

            store.refs.localinfo.header.textContent = header;
            store.refs.localinfo.pickupencourage.innerHTML = subheader;

            store.refs.localinfo.timetitle.textContent = timetitle;
            store.refs.localinfo.btnaccept.textContent = btnaccept;

            store.refs.localinfo.timeerror.textContent = errormessage;
            if (errormessage) {
                store.refs.localinfo.timeerror.parentElement.classList.remove(CLASS_IS_HIDE);
            } else {
                store.refs.localinfo.timeerror.parentElement.classList.add(CLASS_IS_HIDE);
            }

            // Pin
			//O TUU PIN.TITLE
            store.refs.localinfo.pintitle.innerHTML = store.dictionary.localinfo.pin.title;
            store.refs.localinfo.pinprefix.textContent = store.dictionary.localinfo.pin.prefix;
			store.refs.localinfo.pinname.innerHTML = `${store.local.City}<br>${store.local.Address}`;

            store.refs.localinfo.timeinfo.textContent = timeinfo;

            // Time value
            store.refs.localinfo.timevalue.textContent = time;
            if (time) {
                store.refs.localinfo.timevalue.parentElement.classList.remove(CLASS_IS_HIDE);
                store.refs.localinfo.timeinfo.classList.remove(CLASS_IS_HIDE);
            } else {
                store.refs.localinfo.timevalue.parentElement.classList.add(CLASS_IS_HIDE);
                store.refs.localinfo.timeinfo.classList.add(CLASS_IS_HIDE);
            }
        }

        // Hide all for changes
        store.refs.steps.map(sref => {
            sref.style.display = '';
        });

        // Styles will decide if map is visible
        if (store.refs.map) {
            store.refs.map.parentElement.style.display = '';
        }

        // Hide/show common elements
        if (step === 1) {
            store.refs.nav.classList.remove(CLASS_IS_HIDE);
            store.refs.title.parentElement.classList.add(CLASS_ONLY_HEADING);
        } else {
            store.refs.nav.classList.add(CLASS_IS_HIDE);
            store.refs.title.parentElement.classList.remove(CLASS_ONLY_HEADING);
        }
        // Show active step
        store.refs.steps[step - 1].style.display = 'block';

        if (step === 1) {
            // Focus on form field
            const city = store.refs.form.City;
            if (city && !city.value) {
                city.focus();
            }
        }
    }

    scrollToTop();
}

function handleButtonClicks(e: MouseEvent, store: ChangePopupStore) {
    const _target = e.target as HTMLElement;

    // Tab buttons
    if (_target.hasAttribute('data-popupchangeplace-btn')) {
        store.chandeDeliveryType(parseInt(_target.getAttribute('data-popupchangeplace-btn')));
    }
    // Show mobile map
    else if (_target.hasAttribute('data-popupchangeplace-mobilemap')) {
        store.changeStep(3);
    }
    // Back to previous step
    else if (_target.hasAttribute('data-popupchangeplace-localinfo-btndeny')) {
        handleBack(e, store);
    }
    // Set local (delivery or pickup) regardless of IsActive
    else if (_target.hasAttribute('data-popupchangeplace-localinfo-btnaccept')) {
        handleLocalSet({ store, target:_target });
    }
}

/**
 * Update line below tab buttons
 * @param e
 * @param store
 */
function handleResize(e: UIEvent, store: ChangePopupStore) {
    clearTimeout(resizeTimeout);
    resizeTimeout = window.setTimeout(() => {
        store.refs.btns.find(btn => {
            if (btn.type === store.deliveryType) {
                store.refs.line.style.transform = getHighlightValues(btn.ref).transform;
            }
        });
    }, 500);
}

function handleBack(e: Event, store: ChangePopupStore) {
    if (store.step > 1) {
        e.stopPropagation();
        store.changeStep(1);
    }
}

export async function handleLocalSet({store, target, propsLocalId} : {
    store: ChangePopupStore,
    target?: HTMLElement,
    propsLocalId?: string
}) {
    const btnLoader = new Loader();
    target && btnLoader.show(target, true);
    //orderlayer params for analytics
    const orderlayerParam = store.deliveryType == 1 ? 'delivery' : 'pickup';
    dataLayerPush('orderlayer', { evParam1: 'order - pickup', evParam2: orderlayerParam });

    // What user picked
    const localId =propsLocalId || store.local.Id;
    const deliveryType: DeliveryType = target?.hasAttribute('data-delivery')
        ? parseInt(target?.getAttribute('data-delivery'))
        : store.deliveryType;
    const deliveryAddress = JSON.stringify({ ...store.address });

    // What we have in store
    const storeLocalId =
        (!dominosStore.localStore.isLocalNotSet && dominosStore.localStore.local.Id) || '';
    const storeDeliveryType = dominosStore.localStore.deliveryType;
    const storeDeliveryAddress = JSON.stringify({ ...dominosStore.localStore.deliveryAddress });

    // Set local only when something has changed
    if (storeLocalId !== localId || storeDeliveryType !== deliveryType || storeDeliveryAddress !== deliveryAddress) {
        try {
            const response = await dominosStore.localStore.setCurrentLocal(localId, deliveryType);
            if (response.Status) {
                // When local is the same
                if (
                    storeLocalId === localId &&
                    (store.config.oncomplete !== 'menuredirect' || isMenu()) &&
                    store.config.oncomplete !== 'cartredirect'
                ) {
                    // Small cheat to not to have page reload
                    store.config.oncomplete = 'void';
                }

                completeAction(store, response.Data, deliveryType);
            } else {
                store.setStep2Error(
                    response.Message || getAppDefaultMessage('errors.default')
                );
            }

           target && btnLoader.hide();
        } catch (e) {
            if (e?.Message) {
                store.setStep2Error(e.Message);
            }
           target && btnLoader.hide();
        }
    }
    // Nothing changed
    else {
        // Control page redirection
        if (
            (store.config.oncomplete !== 'menuredirect' || isMenu()) &&
            store.config.oncomplete !== 'cartredirect'
        ) {
            // Small cheat to not to have page reload
            store.config.oncomplete = 'void';
        }

        completeAction(store, { ...store.local }, deliveryType);
    }
}

/**
 * What should happen when popup is closing.
 *
 * @param {ChangePopupStore} store
 */
function completeAction(store: ChangePopupStore, resp: LocalMapData, deliveryType: DeliveryType) {
    // closeOverlay should be fired before oncomplete action as we cleanup after popup close
    switch (store.config.oncomplete) {
        case 'menuredirect':
            closeOverlay();
            redirectToMenu();
            break;
        case 'cartredirect':
            closeOverlay();
            redirectToCart();
            break;
        case 'void':
            closeOverlay({ delivery: deliveryType, local: resp, address: { ...store.address } });
            window.location.reload();
            break;
        case 'reload':
        default:
            closeOverlay();
            window.location.reload();
            break;
    }
}

/**
 * Set some config params before popup will appear
 *
 * @param {ChangePopupConfigType} params
 */
function setConfigPCP(params: ChangePopupConfigType) {
    const obj = JSON.stringify(params);
    cookies.create(CONFIG_COOKIE, obj);
}

function manageStep2Error(message: string, store: ChangePopupStore) {
    if (message) {
        store.refs.localinfo.responsestep2.textContent = message;
        store.refs.localinfo.responsestep2.parentElement.classList.remove(CLASS_IS_HIDE);
    } else {
        store.refs.localinfo.responsestep2.parentElement.classList.add(CLASS_IS_HIDE);
        store.refs.localinfo.responsestep2.textContent = '';
    }
}

function openMapPopup(store: ChangePopupStore) {
    const { title, message } = store.dictionary;
    // Changing header title for overlay
    store.refs.title.textContent = title.mobilemap;
    const mapContainerAttribute = 'data-popupchangeplace-only-map-on-overlay';
    // Open overlay with title and map container
    showOverlay(
        'html',
        `<div class='m-Popup__heading'>
            ${store.refs.title.outerHTML}
        </div>
        <div class="m-MapAllPlaces m-ChooseReceiveType__map" data-map-config="MapAllPlacesConfigPopup" ${mapContainerAttribute}>
            <div class="m-MapAllPlaces__cookie-msg">${message.cookie.firstText}<span>${message.cookie.secondText}</span></div>
            <img class="m-MapAllPlaces__cookie-img" src='${ASSETS_PATH}/images/puzzle.svg' alt='puzzle' />
        </div>`
    );
    subscribeToOverlayClose(() => {
        store.maploaded = false;
        store.changeStep(1);
    });
    // Init map on overlay
    store.initMap(false, mapContainerAttribute);
}